import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import {
  FormBuilder,
  FormControl,
  FormGroup,
  Validators,
} from '@angular/forms';
import { Router } from '@angular/router';
import { MessageService } from 'primeng/api';
import { AuthService } from 'src/app/core/auth/auth.service';
import { ApiService } from 'src/app/core/http/api.service';
import { SharedModule } from 'src/app/shared/modules/primeng.module';
import { RecoverPasswordModalComponent } from '../recover-password-modal/recover-password-modal.component';
import { ToastService } from 'src/app/shared/services/toast.service';
import { RestorePasswordComponentComponent } from '../restore-password-component/restore-password-component.component';

@Component({
  selector: 'app-login-modal',
  templateUrl: './login-modal.component.html',
  styleUrls: ['./login-modal.component.css'],
  standalone: true,
  imports: [
    SharedModule,
    RecoverPasswordModalComponent,
    RestorePasswordComponentComponent,
  ],
})
export class LoginModalComponent implements OnInit {
  public processing: boolean = false;
  public operatorBanner: string | null = '';
  public showPassword: boolean = false;
  public operatorLogo: string | null = 'assets/images/no-photo-available.png';
  public keep_session: boolean = true;
  public logo: string | null = 'assets/images/no-photo-available.png';
  public loginForm: FormGroup = this.formBuilder.group({
    user: new FormControl('', [Validators.required]),
    password: new FormControl('', [Validators.required]),
    keepMeSigned: new FormControl(false),
  });

  @Input() showModal: boolean = false;

  @Output() hideModal = new EventEmitter<boolean>();
  @Output() noAccount = new EventEmitter<boolean>();
  @Output() loginSuccess = new EventEmitter<void>(); //block_for_292

  showRecoveryPasswordModal: boolean = false;
  showResetPasswordModal: boolean = false;
  version: string = '';
  cardColor: string = 'transparent';

  constructor(
    private readonly formBuilder: FormBuilder,
    private readonly auth: AuthService,
    private readonly messageService: MessageService,
    private readonly router: Router,
    private readonly apiService: ApiService,
    private readonly toastService: ToastService
  ) {}

  ngOnInit(): void {
    this.getCoorporateConfiguration();
    this.getVersion();
    this.getCardColor();
  }

  private getCardColor() {
    const cardElement = document.querySelector('.card_color');
    if (cardElement) {
      const backgroundColor =
        window.getComputedStyle(cardElement).backgroundColor;
      this.cardColor = backgroundColor;
    }
  }

  //hide modal
  public emitHideModal(): void {
    this.showModal = false;
    this.loginForm.reset();
    this.loginForm.get('keepMeSigned')?.setValue(false);
    this.hideModal.emit(this.showModal);
  }

  public login(): void {
    if (this.processing) return;
    this.processing = true;
    const user = this.loginForm.get('user')?.value;
    const pass = this.loginForm.get('password')?.value;
    const keepMeSigned = this.loginForm.get('keepMeSigned')?.value;

    this.auth.login(user, pass, keepMeSigned[0] ?? false).subscribe({
      next: (res) => {
        if (res.reset_password) {
          this.showResetPasswordModal = true;
        } else {
          this.toastService.showSuccess('Bienvenido');
          setTimeout(() => {
            this.processing = false;
            this.emitHideModal();
            this.loginSuccess.emit();
          }, 1000);
        }
      },
      error: (error) => {
        this.processing = false;
        this.toastService.showError('Credenciales incorrectas', '');
        console.error(error);
      },
    });
  }
  onHideResetPasswordModal(): void {
    this.showResetPasswordModal = false;
    this.processing = false;
  }

  public clearToast(): void {
    this.messageService.clear('tc');
  }

  private getCoorporateConfiguration(): void {
    // this.showLoadSkeleton.wallet = true;
    // this.showLoadSpin = true;
    this.apiService.getCoorporateCasinoConfig().subscribe({
      next: (res) => {
        this.logo = res.data.logoCasinoUrl;
        // this.showLoadSkeleton.wallet = false;
        // this.showLoadSpin = false;
      },
      error: (err) => console.error(err),
    });
  }

  public emmitNoAccount(): void {
    this.noAccount.emit(true);
  }

  showResetPassword() {
    this.showModal = false;
    this.emitHideModal();
    this.showRecoveryPasswordModal = true;
  }

  getVersion = () => {
    this.apiService.getWebVersion().subscribe((res) => {
      this.version = res.version;
    });
  };
  togglePasswordVisibility() {
    this.showPassword = !this.showPassword;
  }
}
